/**
 * Rounds `val` down to a multiple of `nearest`
 */
const roundToNearest = (
  val: number,
  nearest: number,
): number => Math.floor(val / nearest) * nearest;

export default roundToNearest;
